import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ContactPreferenceHistory } from '../../../models/contact-preference-history/contact-preference-history.model';
import { ContactPreferenceHistorySerializer } from '../../../models/contact-preference-history/contact-preference-history-serializer.class';
import { CustomErrorHandlerService } from '../custom-error-handler.service';

@Injectable()
export class ContactPreferenceHistoryService extends BaseApiService<ContactPreferenceHistory> {
  constructor(httpClient: HttpClient) {
    super(
        httpClient, 
        null, 
        "contactpreferenceshistory", 
        new ContactPreferenceHistorySerializer(), 
        new CustomErrorHandlerService());
  }
}
